import { render, staticRenderFns } from "./normatividadFinanciera.vue?vue&type=template&id=b12895ce&scoped=true"
import script from "./normatividadFinanciera.vue?vue&type=script&lang=js"
export * from "./normatividadFinanciera.vue?vue&type=script&lang=js"
import style0 from "./normatividadFinanciera.vue?vue&type=style&index=0&id=b12895ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12895ce",
  null
  
)

export default component.exports